$.fn.serializeElement = function($inputs) {
    // https://github.com/jquery/jquery/blob/9cb162f6b62b6d4403060a0f0d2065d3ae96bbcc/src/serialize.js#L102
    return $inputs.map( function() {

        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop( this, "elements" );
        return elements ? jQuery.makeArray( elements ) : this;
    } )
    .filter( function() {
        var type = this.type;

        // Use .is( ":disabled" ) so that fieldset[disabled] works
        return this.name && !jQuery( this ).is( ":disabled" ) &&
            /^(?:input|select|textarea|keygen)/i.test( this.nodeName ) && !/^(?:submit|button|image|reset|file)$/i.test( type ) &&
            ( this.checked || !/^(?:checkbox|radio)$/i.test( type ) );
    } );
}